import React from 'react';

export default function TitleLinksFooter({ children }) {
    return <h3 className="mb-1 text-sm font-bold tracking-wide text-gray-900 uppercase">{children}</h3>;
}
